import React, {createContext, ReactNode, useContext, useState} from "react";
import {ColleagueModel, ColleagueUpdateContextType} from "../types/users";

const ColleaguesContext = createContext<ColleagueUpdateContextType | undefined>(undefined);

export const ColleagueModelProvider = ({children}: { children: ReactNode }) => {
    const [model, setModel] = useState<ColleagueModel>({
        colleague_pk: null,

        type: 'COLLEAGUE',

        full_name: null,
        phone: null,

        tickets_need: true,
        hotel_need: true,
        other_documents_need: true,
        uploadingFiles: [],
        deletingFiles: [],
    });

    // Обновление главной модели
    const updateModel = (updates: Partial<ColleagueModel>) => {
        setModel((prevModel) => ({
            ...prevModel,
            ...updates,
        }));
    };
    const resetModel = () => {
        setModel({
            colleague_pk: null,
            type: 'COLLEAGUE',
            full_name: null,
            phone: null,
            tickets_need: true,
            hotel_need: true,
            other_documents_need: true,
            uploadingFiles: [],
            deletingFiles: [],
        });
    };


    return (
        <ColleaguesContext.Provider value={{model, updateModel, resetModel}}>
            {children}
        </ColleaguesContext.Provider>
    );
};

export const useColleagueModel = () => {
    const context = useContext(ColleaguesContext);
    if (context === undefined) {
        throw new Error('Использование модели должно быть внутри связанного с ней провайдера');
    }
    return context;
};